export interface QtyAndName {
    qty: number;
    name: string;
}

export class ImportParseError extends Error {
    constructor(public message, public start, public end) {
        super(message);
        this.name = ImportParseError.name;
    }
}

export class BadQuantity extends ImportParseError {
    constructor(message, start, end) {
        super(message, start, end);
        this.name = BadQuantity.name;
    }
}

export class IncorrectColumnCount extends ImportParseError {
    constructor(message, start, end) {
        super(message, start, end);
        this.name = IncorrectColumnCount.name;
    }
}

export class IncorrectColumnType extends ImportParseError {
    constructor(message, start, end) {
        super(message, start, end);
        this.name = IncorrectColumnType.name;
    }
}

export abstract class ImportParser {
    public abstract parse(text: string): QtyAndName[] | null;
}
